import { render, staticRenderFns } from "./RelationTask.vue?vue&type=template&id=9296c1c6"
import script from "./RelationTask.vue?vue&type=script&lang=js"
export * from "./RelationTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports